import type { SVGProps } from 'react';
const SvgContactUsFaqStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.518.66H1.982A1.32 1.32 0 0 0 .661 1.983v11.232a1.32 1.32 0 0 0 1.321 1.322h2.643v3.303l4.123-3.303h7.77a1.32 1.32 0 0 0 1.321-1.322V1.982A1.32 1.32 0 0 0 16.518.661" />
      <path d="m7.103 9.91 1.352-4.403a.313.313 0 0 1 .599 0l1.352 4.404M7.475 8.699h2.56M12.352 6.708v1.918a1.422 1.422 0 0 0 2.844 0V6.708a1.422 1.422 0 1 0-2.844 0" />
      <path d="M13.774 10.081v.232c0 .51.415.925.926.925M3.304 9.91V5.287h2.422M3.304 7.57H5.34" />
    </g>
  </svg>
);
export default SvgContactUsFaqStreamlineCore;
